import config from '../../capacitor.config';
import { Capacitor } from '@capacitor/core';

export const domain = 'dev-xf0s7kly6scrwc2a.us.auth0.com';
export const clientId = 'T3N4DyIoBDg6cV3f9rjNceAFCXPyyi0u';
const { appId } = config;

// Use `auth0Domain` in string interpolation below so that it doesn't
// get replaced by the quickstart auto-packager
const auth0Domain = domain;
const iosOrAndroid = Capacitor.getPlatform()!="web";
function getHostName(){
  const loc = window.location.protocol;
  const host = window.location.hostname;
  const port = window.location.port
 
  if(Capacitor.getPlatform()!="web"){
    return `${appId}://${auth0Domain}/capacitor/${appId}/callback`;
  }
 
  if (host.includes('localhost')){
    return "http://localhost:4500";
  
  }else{
  return  "https://myfoodgenie.in";
  }
}
export const callbackUri = getHostName();
// export const callbackUri = `${appId}://${auth0Domain}/capacitor/${appId}/callback`;
// 'http://localhost:4500';
// 'https://navifoodmart.com/nfmgenie';